"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * cloudcore-airing
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalDataCollectionTypeEnum = void 0;
exports.InternalDataCollectionTypeEnum = {
    Movie: 'movie',
    Playlist: 'playlist',
    Series: 'series',
    Song: 'song',
    Special: 'special',
    Webvideo: 'webvideo'
};
